<template>
  <form>
    <md-card style="height: 372px;">
      <md-card-header class="md-card-header-text md-card-header-green">
        <div class="card-text">
          <h4 class="title">Wishlist</h4>
          <p class="category">Student Wishlist</p>
        </div>
      </md-card-header>
      <md-card-content class="md-size-50 mx-auto" v-if="table_spinner">
        <md-progress-spinner md-mode="indeterminate"></md-progress-spinner>
      </md-card-content>
      <md-card-content style="overflow: auto;">
        <md-table
          v-show="!table_spinner"
          v-model="applications"
          table-header-color="green"
        >
          <md-table-empty-state
            md-label="No wishlist found"
            :md-description="`No wishlist found for this student.`"
          >
          </md-table-empty-state>
          <md-table-row slot="md-table-row" slot-scope="{ item }">
            <md-table-cell md-label="Program">{{
              item.program.name
            }}</md-table-cell>
            <md-table-cell md-label="Season">{{
              item.season.name
            }}</md-table-cell>
            <md-table-cell md-label="Status">{{
              item.application_status
            }}</md-table-cell>
            <md-table-cell md-label="Action" style="width: 2%">
              <md-button
                class="md-just-icon md-info md-round"
                @click.native="handleEdit(item)"
              >
                <md-icon>fact_check</md-icon>
                <md-tooltip md-direction="bottom">Detail</md-tooltip>
              </md-button>
            </md-table-cell>
          </md-table-row>
        </md-table>
      </md-card-content>
    </md-card>
  </form>
</template>
<script>
export default {
  name: "edit-profile-form",
  props: {
    headerColor: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      userID: null,
      applications: [],
      table_spinner: true
    };
  },
  methods: {
    getClass: function(headerColor) {
      return "md-card-header-" + headerColor + "";
    },
    handleEdit(item) {
      this.$router.push({
        name: "Application Update",
        params: { application_id: item.id }
      });
    }
  },
  mounted() {
    this.table_spinner = false;
    //   this.userID = this.$route.params.id
    //   this.$store.getApplicationsWithParam(
    //       {user_id: this.userID}
    //   ).then(response => {
    //     this.applications = response.data.results
    //     this.table_spinner = false
    //   }).catch(error => {
    //     this.table_spinner = false
    //     this.$notify({
    //       message: error.message,
    //       icon: 'add_alert',
    //       type: "warning",
    //       verticalAlign: "top",
    //     })
    //   })
  }
};
</script>
<style></style>
